export default "__VITE_ASSET__2iIbKoyn__"